window.destroyRealAlert = function(){
    function destroyAlert() {
        $('.alert-hidden').alert('close');
    }
    setTimeout(destroyAlert, 5000);
}
document.addEventListener("turbolinks:load", function() {
    destroyRealAlert();
})